import { OFFLINE_CACHE_FLAG } from './config';
import { warmPublicCaches } from './offlineCacheClient';

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

async function clearAppCaches(): Promise<void> {
  if (typeof window === 'undefined' || !('caches' in window)) return;
  try {
    const keys = await caches.keys();
    await Promise.all(
      keys
        .filter((key) => key.startsWith('aa-'))
        .map((key) => caches.delete(key)),
    );
  } catch {
    // Ignore cache cleanup errors.
  }
}

async function removeStaleRegistrations(): Promise<void> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  const getRegistrations = navigator.serviceWorker.getRegistrations;
  if (typeof getRegistrations !== 'function') return;
  try {
    const registrations = await getRegistrations.call(navigator.serviceWorker);
    await Promise.all(
      registrations
        .filter((registration) => {
          try {
            return new URL(registration.active?.scriptURL || registration.installing?.scriptURL || registration.waiting?.scriptURL || '', window.location.origin).pathname === '/sw.js';
          } catch {
            return false;
          }
        })
        .map((registration) => registration.unregister()),
    );
  } catch {
    // Ignore stale service worker cleanup errors.
  }
}

export async function registerAppServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }

  if (registrationPromise) return registrationPromise;

  registrationPromise = (async () => {
    try {
      if (!OFFLINE_CACHE_FLAG) {
        await removeStaleRegistrations();
        await clearAppCaches();
      }
      const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      await registration.update?.();
      await navigator.serviceWorker.ready;
      if (OFFLINE_CACHE_FLAG) {
        await warmPublicCaches();
      }
      return registration;
    } catch {
      return null;
    }
  })();

  return registrationPromise;
}

export const isOfflineCachingEnabled = OFFLINE_CACHE_FLAG;
